import React from 'react';

export function BB2HTML(value) {
    const format_search = [
        /\[b\](.*?)\[\/b\]/ig,
        /\[i\](.*?)\[\/i\]/ig,
        /\[u\](.*?)\[\/u\]/ig,
        /\[s\](.*?)\[\/s\]/ig,

        /\[h2\](.*?)\[\/h2\]/ig,
        /\[h3\](.*?)\[\/h3\]/ig,
        /\[sup\](.*?)\[\/sup\]/ig,
        /\[sub\](.*?)\[\/sub\]/ig,
        // /\[list=column\].*|\s*(\[\*\](.*))+.*|\s*\[\/list\]/ig,
        /\[list=column\]((?:.|\t|\n|\r)*?)\[\/list\]/ig,
        /\[list=123\]((?:.|\t|\n|\r)*?)\[\/list\]/ig,
        /\[list=\]((?:.|\t|\n|\r)*?)\[\/list\]/ig,
        /\[\*\](.*?)\n/ig,

        /\[url=(.*?)\](.*?)\[\/url\]/ig,
        /\[twitter=(.*?)\](.*?)\[\/twitter\]/ig,
        /\[games_download=(.*?)\](.*?)\[\/games_download\]/ig,
    ]; // note: NO comma after the last entry

    const format_replace = [
        '<b>$1</b>',
        '<i>$1</i>',
        '<u>$1</u>',
        '<s>$1</s>',

        '<h2>$1</h2>',
        '<h3>$1</h3>',
        '<sup>$1</sup>',
        '<sub>$1</sub>',

        '<div>$2</div>',
        '<ol>$1</ol>',
        '<ul>$1</ul>',
        '<li>$1</li>',

        '<a href=$1>$2</a>',
        '<a href="https://twitter.com/$1">$2</a>',
        '<a href=$1>$2</a>',
    ];

    let result = value;

    for (let i = 0; i < format_search.length; i++) {
        result = result.replace(format_search[i], format_replace[i]);
    }

    return <div dangerouslySetInnerHTML={{ __html: result }} />;
}
